<template>
  <div class="h-8 md:h-11 w-22.5 md:w-32 px-3 py-1 bg-white rounded">
    <img :src="source" alt="" class="w-full h-full object-contain">
  </div>
</template>

<script>
export default {
  name: 'OrganizationLogo',
  props: {
    source: {
      type: String,
      required: true
    }
  }
}
</script>